import React, { lazy, Suspense } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Loader from "../Component/Common/Loader";
import NotFound from "../Component/Common/NotFound";
import MatchScorcard from "../Component/Fixture/MatchScorcard";
import PlayerProfile from "../Component/Player/PlayerProfile";
import MctAccount from "../Component/MctAccount";
import BlogDetail from "../Component/Blog/BlogDetail";
import UpdateProfile from "../Component/UpdateProfile/UpdateProfile";
import HowItWork from "../Component/HowItWork/HowItWork";
import Refund from "../Component/Refund/Refund";
import Privacy from "../Component/Privacy/Privacy";
import TermCondition from "../Component/TermCondition/TermCondition";
import About from "../Component/About/About";
import ForgotPassword from "../Component/ForgotPassword/ForgotPassword";
import AccountVerification from "../Component/ForgotPassword/AccountVerification";
import ResetPassword from "../Component/ForgotPassword/ResetPassword";
import Testimonial from "../Component/Common/Testimonial";
import AdminLogin from "../Component/Login/AdminLogin";
import Timeline from "../Component/Timeline/Timeline";
import MyPlayerProfile from "../Component/Player/MyPlayerProfile";
import ShowH2H from "../Component/HeadToHead/ShowH2H";
import ShowAllTypeH2H from "../Component/HeadToHead/ShowAllTypeH2H";
import ViewAllPlayOff from "../Component/HeadToHead/VIewAllPlayOff";
import PlayerChart from "../Component/GameGraph/PlayerGraph";
import GameChart from "../Component/GameGraph/GameChart";
import Team from "../Component/Team/Team";
import FeatureDetail from "../Component/Feature/FeatureDetail";
import GamePlayerProfile from "../Component/GamePlayer/GamePlayerProfile";
import GuestGameChart from "../Component/GameGraph/GuestGameChart";
import ChangePassword from "../Component/UpdateProfile/ChangePassword";
import ProMemberSuccess from "../Component/GamePass/ProMemberSuccess";
import RoundPage from "../Component/Rounds/RoundPage";
import PointSystem from "../Component/Rounds/PointSystem";
import TeamMatchScorcard from "../Component/Fixture/TeamMatchScorecard";
import AveragePointStats from "../Component/RoundStats/AveragePointStats";
import MyRank from "../Component/Rank/MyRank";
import DownloadCards from "../Component/DownloadCards/DownloadCards";
import MyPlayers from "../Component/Player/MyPlayers";
import AboutGame from "../Component/AccountHub/AboutGame";
import UserPreference from "../Component/UpdateProfile/UserPreference";

const Login = lazy(() => import("../Component/Login/Login"));
const Homepage = lazy(() => import("../Component/Homepage"));
const MyTeam = lazy(() => import("../Component/MyTeam"));
const Rounds = lazy(() => import("../Component/Rounds"));
const History = lazy(() => import("../Component/History"));
const Sponsor = lazy(() => import("../Component/Sponsor"));
const PlayerSponsor = lazy(() => import("../Component/PlayerSponsor"));
const Player = lazy(() => import("../Component/Player"));
const Fixture = lazy(() => import("../Component/Fixture"));
const GameMember = lazy(() => import("../Component/GameMember"));
const TeamOfTheWeek = lazy(() => import("../Component/TeamOfTheWeek"));
const Article = lazy(() => import("../Component/Article"));
const GameArticle = lazy(() => import("../Component/GameArticle"));
const ArticleDetail = lazy(() => import("../Component/Article/ArticleDetail"));
const TradeHistory = lazy(() => import("../Component/TradeHistory"));
const Rank = lazy(() => import("../Component/Rank"));
const Stat = lazy(() => import("../Component/Stat"));
const GameStat = lazy(() => import("../Component/GameStat"));
const Prize = lazy(() => import("../Component/Prize"));
const UserProfile = lazy(() => import("../Component/UserProfile"));
const Dashboard = lazy(() => import("../Component/Dashboard"));
const Rule = lazy(() => import("../Component/Rule"));
const Faq = lazy(() => import("../Component/Faq"));
const GameSignup = lazy(() => import("../Component/GameSignup"));
const CustomGameRegister = lazy(() =>
  import("../Component/GameSignup/CustomGameRegister")
);
const UserSignup = lazy(() => import("../Component/UserSignup"));
const BonusCard = lazy(() => import("../Component/BonusCard"));
const GameListing = lazy(() => import("../Component/GameListing"));
const MyGames = lazy(() => import("../Component/MyGames"));
const Blog = lazy(() => import("../Component/Blog"));
const Notification = lazy(() => import("../Component/Notification"));
const BracketBattle = lazy(() => import("../Component/BracketBattle"));
const GamePass = lazy(() => import("../Component/GamePass"));
const MyAccount = lazy(() => import("../Component/MyAccount"));
const Feature = lazy(() => import("../Component/Feature"));
const ShowCase = lazy(() => import("../Component/ShowCase"));
const HowToPlay = lazy(() => import("../Component/HowToPlay"));
const Member = lazy(() => import("../Component/Member"));
const Partner = lazy(() => import("../Component/Partner"));
const GamePartner = lazy(() => import("../Component/GamePartner"));
const PressRelease = lazy(() => import("../Component/PressRelease"));
const WhatsNew = lazy(() => import("../Component/WhatsNew"));
const UserAllGame = lazy(() => import("../Component/UserAllGame"));
const ActiveGame = lazy(() => import("../Component/ActiveGame"));
const AccountHub = lazy(() => import("../Component/AccountHub"));
const GameRank = lazy(() => import("../Component/GameRank"));
const GamePlayer = lazy(() => import("../Component/GamePlayer"));
const PressReleaseDetail = lazy(() =>
  import("../Component/PressRelease/DetailPage")
);
const WhatsNewDetail = lazy(() => import("../Component/WhatsNew/DetailPage"));
const Pricing = lazy(() => import("../Component/Pricing"));
const TradeLogs = lazy(() => import("../Component/TradeLogs"));

const RoutesPage = () => {
  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route
          path="/admin"
          element={<Navigate replace to="http://cricket.myclubtap.com/admin" />}
        />
        <Route path="/" element={<Homepage />} />
        <Route path="/not-found" element={<NotFound />} />
        <Route path="*" element={<Navigate replace to="/not-found" />} />
        <Route path={"/login"} element={<Login />} />
        <Route path={"/adminLogin/:id"} element={<AdminLogin />} />
        <Route
          path={"/account-verification/:verificationLink"}
          element={<AccountVerification />}
        />
        <Route path={"/forgot-password"} element={<ForgotPassword />} />
        <Route
          path={"/reset-password/:verificationLink"}
          element={<ResetPassword />}
        />
        <Route path={"/game-accounts"} element={<MctAccount />} />
        <Route path={"/my-team"} element={<MyTeam />} />
        <Route path={"/rounds"} element={<Rounds />} />
        <Route path={"/round-stats"} element={<AveragePointStats />} />
        <Route path={"/rounds-trades-windows"} element={<RoundPage />} />
        <Route path={"/point-system"} element={<PointSystem />} />
        <Route path={"/history"} element={<History />} />
        <Route path={"/sponsors"} element={<Sponsor />} />
        <Route path={"/player-sponsors"} element={<PlayerSponsor />} />
        <Route path={"/players"} element={<Player />} />
        <Route path={"/player-charts"} element={<PlayerChart />} />
        <Route path={"/game-charts"} element={<GameChart />} />
        <Route path={"/guest-game-charts"} element={<GuestGameChart />} />
        <Route path={"/member-game-charts"} element={<GameChart />} />
        <Route path={"/player-profile/:id"} element={<PlayerProfile />} />
        <Route path={"/my-player-profile/:id"} element={<MyPlayerProfile />} />
        <Route path={"/fixtures"} element={<Fixture />} />
        <Route path={"/match-scorecard/:id"} element={<MatchScorcard />} />
        <Route
          path={"/team-scorecard/:id/:teamId"}
          element={<TeamMatchScorcard />}
        />
        <Route path={"/game-members"} element={<GameMember />} />
        <Route path={"/team-of-the-round"} element={<TeamOfTheWeek />} />
        <Route path={"/articles"} element={<Article />} />
        <Route path={"/game-articles"} element={<GameArticle />} />
        <Route path={"/article-details/:slug"} element={<ArticleDetail />} />
        <Route path={"/trade-history"} element={<TradeHistory />} />
        <Route path={"/rank"} element={<Rank />} />
        <Route path={"/my-rank"} element={<MyRank />} />
        <Route path={"/stats"} element={<Stat />} />
        <Route path={"/downloads"} element={<DownloadCards />} />
        <Route path={"/timeline"} element={<Timeline />} />
        <Route path={"/game-stats"} element={<GameStat />} />
        <Route path={"/prize"} element={<Prize />} />
        <Route path={"/member-profile/:slug"} element={<UserProfile />} />
        <Route path={"/dashboard"} element={<Dashboard />} />
        <Route path={"/my-profile"} element={<Dashboard />} />
        <Route path={"/rules"} element={<Rule />} />
        <Route path={"/start-game"} element={<CustomGameRegister />} />
        {/* <Route
          path={"/custom-game-register"}
          element={<CustomGameRegister />}
        /> */}
        <Route path={"/member-signup"} element={<UserSignup />} />
        <Route path={"/faqs"} element={<Faq />} />
        <Route path={"/bonus-card"} element={<BonusCard />} />
        <Route path={"/game-teams"} element={<Team />} />

        <Route path={"/account"} element={<GameListing />} />
        <Route path={"/my-games"} element={<MyGames />} />
        <Route path={"/blogs"} element={<Blog />} />
        <Route path={"/blog-details/:slug"} element={<BlogDetail />} />
        <Route path={"/notifications"} element={<Notification />} />
        <Route path={"/bracket-battle"} element={<BracketBattle />} />
        <Route path={"/head-2-head"} element={<ShowH2H />} />
        <Route path={"/view-h2h/:roundId"} element={<ShowAllTypeH2H />} />
        <Route path={"/view-playoff/:id"} element={<ViewAllPlayOff />} />
        <Route path={"/promembership"} element={<GamePass />} />
        <Route path={"/pro-member-success"} element={<ProMemberSuccess />} />
        <Route path={"/billings"} element={<MyAccount />} />
        <Route path={"/features"} element={<Feature />} />
        <Route path={"/showcase"} element={<ShowCase />} />
        <Route path={"/feature-details/:id"} element={<FeatureDetail />} />
        <Route path={"/how-to-play"} element={<HowToPlay />} />
        <Route path={"/how-it-works"} element={<HowItWork />} />
        <Route path={"/about-us"} element={<About />} />
        <Route path={"/members"} element={<Member />} />
        <Route path={"/partner-with-us"} element={<Partner />} />
        <Route path={"/game-partners"} element={<GamePartner />} />
        <Route path={"/press-release"} element={<PressRelease />} />
        <Route path={"/press-detail/:id"} element={<PressReleaseDetail />} />

        <Route path={"/whats-new"} element={<WhatsNew />} />
        <Route path={"/whats-new-detail/:id"} element={<WhatsNewDetail />} />

        <Route path={"/pricing"} element={<Pricing />} />
        <Route path={"/join-game"} element={<UserAllGame />} />
        <Route path={"/live-games"} element={<ActiveGame />} />

        <Route path={"/account-hub"} element={<AccountHub />} />
        <Route path={"/game-rank"} element={<GameRank />} />
        <Route path={"/game-players"} element={<GamePlayer />} />
        <Route
          path={"/game-player-profile/:id"}
          element={<GamePlayerProfile />}
        />
        <Route path={"/update-profile"} element={<UpdateProfile />} />
        <Route path={"/my-preferences"} element={<UserPreference />} />
        <Route path={"/change-password"} element={<ChangePassword />} />
        <Route path={"/refund"} element={<Refund />} />
        <Route path={"/privacy"} element={<Privacy />} />
        <Route path={"/terms-of-use"} element={<TermCondition />} />
        <Route path={"/testimonials"} element={<Testimonial />} />
        <Route path={"/trade-logs"} element={<TradeLogs />} />
        <Route path={"/my-players"} element={<MyPlayers />} />
        <Route path={"/about-game"} element={<AboutGame />} />
      </Routes>
    </Suspense>
  );
};

export default RoutesPage;
